<template>
  <CmStateCard
    :isLoading="isLoading"
    :isError="isError"
    :isEmpty="!value || (value && !value.length)"
    class="cm-state-card--grouped-bar"
  >
    <CmGroupedBar
      mainKey="date"
      :labels="labels"
      :value="value"
      :colors="colors"
    />
  </CmStateCard>
</template>

<script>
import CmStateCard from '@/components/library/statistics/cards/CmStateCard.vue';
import CmGroupedBar from "@/components/library/statistics/elements/CmGroupedBar";
import notification_mixin from "@/components/statistics/stats/tabs/notification_mixin";

export default {
  mixins: [notification_mixin],

  components: {
    CmStateCard,
    CmGroupedBar,
  },

  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    isError: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      colors: ["#56D9FE", '#7370FF', '#FFDA83'],
      labels: {
        delivered: "Доставлено",
        clickedTotal: "Переходов",
        clicked: "Уникальных переходов",
      },
    };
  },

  created() {
    if (this.isNotification)
      delete this.labels.delivered;
  },
};
</script>
